import { useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Mazu, Sheet, SheetContent } from '@ledgerloom/ui';
import { hasSurface, useSession } from '../session';
import type { ChatState } from './AskAgent';
import { HelpChat } from './HelpChat';

// The Mazu head in the top bar opens the help agent's chat in a panel on the right,
// asked from the screen you are on (docs/plans/agent-ui-plan.md, the brand standard
// of 2026-11-02). The head shows what the chat is doing. It is there while the help
// agent is hired. Esc closes the panel and returns to the head. Patterns:
// overlays/drawer, ai-intelligence/ai-chat.
export function HelpButton() {
  const { me } = useSession();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [state, setState] = useState<ChatState>('idle');
  const head = useRef<HTMLButtonElement>(null);
  if (!hasSurface(me, 'help') || pathname === '/help') return null;
  return (
    <>
      <button ref={head} type="button" aria-label="Help" aria-haspopup="dialog" aria-expanded={open} onClick={() => setOpen(true)}
        className="grid size-11 shrink-0 place-items-center rounded-pill can-hover:hover:bg-surface-muted">
        <Mazu state={state} size={32} />
      </button>
      <Sheet open={open} onOpenChange={(next) => { setOpen(next); if (!next) setState('idle'); }}>
        <SheetContent title="Help" className="w-[min(28rem,100vw)]"
          // The chat loads after the panel opens, so the panel itself takes focus.
          onOpenAutoFocus={(e) => { e.preventDefault(); (e.currentTarget as HTMLElement).focus(); }}
          onCloseAutoFocus={(e) => { e.preventDefault(); head.current?.focus(); }}>
          <HelpChat level={3} page={pathname} onState={setState} />
        </SheetContent>
      </Sheet>
    </>
  );
}
